import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import MainHeader, { MENU_REPORT } from "../../components/common/MainHeader";
import { WOOD_IMPORT_GRADE_DISPLAY } from "../../constance/dataTypes";
import ReportDetail from "../../components/reports/ReportDetail";
import { URL_BARCODE } from "../../constance/urls";
import { formatComma } from "../../utils/stringFormat";
import ReportExportButton from "../../components/common/ReportExportButton";
import { Row, Col, DatePicker, Select, Button, Form, Typography } from "antd";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";

export default function ReportWoodImportByWoodCode() {
  const { t } = useTranslation();
  const [queryParams, setQueryParams] = React.useState(null);

  const [form] = Form.useForm();
  const date = Form.useWatch("dateRange", form);
  const grade = Form.useWatch("wood_grade_options", form);
  const [errors, setErrors] = useState({});

  const ref = useRef();

  const columns = React.useMemo(
    () => [
      {
        title: "",
        dataIndex: "general_info",
        children: [
          {
            title: "รหัสสินค้า",
            dataIndex: "wood_code",
          },
          {
            title: "จำนวนส่ง (ท่อน)",
            dataIndex: "report.total_woods",
            render: (text, record) =>
              formatComma(record.report?.total_woods, 0),
          },
        ],
      },
      {
        title: "ไม้ดี",
        dataIndex: "good_wood_info",
        children: [
          {
            title: "ท่อน",
            dataIndex: "report.good_woods",
            render: (text, record) => formatComma(record.report?.good_woods, 0),
          },
          {
            title: "ลบ. ฟ.",
            dataIndex: "report.good_volume",
            render: (text, record) => formatComma(record.report?.good_volume),
          },
        ],
      },
      {
        title: "ไม้เสีย",
        dataIndex: "waste_wood_info",
        children: [
          {
            title: "ท่อน",
            dataIndex: "report.waste_woods",
            render: (text, record) =>
              formatComma(record.report?.waste_woods, 0),
          },
          {
            title: "ลบ. ฟ.",
            dataIndex: "report.waste_volume",
            render: (text, record) => formatComma(record.report?.waste_volume),
          },
        ],
      },
      {
        title: "",
        dataIndex: "price",
        children: [
          {
            title: "จำนวนเงิน (บาท)",
            dataIndex: "report.buy_amount",
            render: (text, record) => formatComma(record.report?.buy_amount),
          },
        ],
      },
    ],
    []
  );

  const wood_grade_options = [
    { value: "ALL", key: "all", label: t("all") },
    ...WOOD_IMPORT_GRADE_DISPLAY.map((grade) => {
      const text = String(grade).toLocaleUpperCase();
      console.log({ grade, text });
      return { value: grade, key: grade, label: text };
    }),
  ];

  const getQueryParams = () => {
    const values = form.getFieldsValue();
    const startDate = dayjs(values.dateRange[0]).format(DATE_FORMAT);
    const endDate = dayjs(values.dateRange[1]).format(DATE_FORMAT);
    const queryString = `date_after=${startDate}&date_before=${endDate}&grade=${grade}`;
    return queryString;
  };

  const validateForm = () => {
    const values = form.getFieldsValue();
    const newErrors = {};
    if (!values.dateRange || values.dateRange.length < 2)
      newErrors.dateRange = t("error_messages.validation.required");
    if (!grade) newErrors.grade = t("error_messages.validation.required");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  React.useEffect(() => {
    if (validateForm()) {
      if (ref.current) {
        const params = getQueryParams();
        ref.current.refetch(params);
        setQueryParams(params);
      }
    }
  }, [date, grade]);

  return (
    <div style={{ margin: "24px", marginTop: "7em" }}>
      <MainHeader activeItem={MENU_REPORT} />
      <Typography.Title level={2}>
        {t("menus.report_menus.wood_import_menus.wood_import_by_wood_code")}
      </Typography.Title>
      <Form
        layout="horizontal"
        form={form}
        initialValues={{
          wood_grade_options: "AB",
          dateRange: [],
        }}
      >
        <Row gutter={16}>
          <Col sm={24} md={24} lg={6}>
            <Form.Item
              label={t("filter")}
              name="dateRange"
              rules={[{ required: true, message: t("กรุณาเลือกช่วงเวลา") }]}
            >
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                placeholder={[
                  t("searchs.placeholders.startDate"),
                  t("searchs.placeholders.endDate"),
                ]}
                format={HUMAN_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col sm={24} md={24} lg={6}>
            <Form.Item
              label={t("wood_imports.grade")}
              name="wood_grade_options"
            >
              <Select options={wood_grade_options} />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: "right" }}>
          {["pdf", "excel"].map((type) => (
            <ReportExportButton
              url={`${URL_BARCODE.REPORT_WOOD_IMPORT_WOOD_CODE_EXPORT}${type}/?${queryParams}`}
              type={type}
              title={`${t(
                "menus.report_menus.wood_import_menus.wood_import_by_wood_code"
              )}.....`}
              disabled={queryParams == null}
            />
          ))}
        </div>
      </Form>
      <ReportDetail
        ref={ref}
        reportUrl={URL_BARCODE.REPORT_WOOD_IMPORT_WOOD_CODE}
        columns={columns}
      />
    </div>
  );
}
